<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { Primitive, type PrimitiveProps } from 'reka-ui'

const props = withDefaults(defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>(), {
  as: 'a',
  class: null
})
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="cn('text-blue-600 transition-colors hover:text-blue-700', props.class)"
  >
    <slot />
  </Primitive>
</template>
